module.exports = __webpack_public_path__ + "img/clouds-compressed.96927bb.png";